module.exports = "/_next/static/images/dbfc43dbca5c7fd769889dcb0fbdf656-pay-yourself-xs@2x.jpg";